export default {
  menu: {
    base: {
      borderColor: 'grey-40'
    }
  },
  item: {
    base: {
      wrapper: {
        borderColor: 'grey-40'
      },
      icon: {
        borderColor: 'primary'
      }
    },
    variants: {
      hover: {
        backgroundColor: 'grey-05'
      },
      focus: {
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: 'orange',
        backgroundColor: 'white',
        padding: 14
      },
      checked: {
        backgroundColor: 'white',
        color: 'black'
      }
    }
  }
};